import View from "../../../Nav/Js/views/StoreFinderView";
import components from "./components.js";
components.define("js-StoreFinderView", View);